export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/scripts/requiredFieldsCollector.worker.5ecad440.bundle.worker.js");
}
